import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Divider,
  Flex,
  FormLabel,
  HStack,
  IconButton,
  Img,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  VStack,
  Icon,
  createIcon,
  SimpleGrid,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loginGoogleUser, loginUser } from "../../actions/user/userActions";
import sylvr_logo from "../../assets/images/sylvr-logo-register.png";
import "./login.scss";
import { useEffect } from "react";
import { GoogleIcon } from "./OAuthGroup/ProviderIcons";
import { useGoogleLogin } from "@react-oauth/google";
import { useLinkedIn } from "react-linkedin-login-oauth2";
import linkedin_icon from "../../assets/icons/linkedin-icon.png";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import FoodKindredProductsIcon from "../../components/Icons/FoodKindredProductsIcon";
import FabricatedMetalProductsIcon from "../../components/Icons/FabricatedMetalProductsIcon";
import PaperAlliedProductsIcon from "../../components/Icons/PaperAlliedProductsIcon";
import IndustrialCommercialMachineryComputerEquipmentIcon from "../../components/Icons/IndustrialCommercialMachineryComputerEquipmentIcon";
import TextileMillProductsIcon from "../../components/Icons/TextileMillProductsIcon";
import TransportationEquipmentIcon from "../../components/Icons/TransportationEquipmentIcon";
import ApparelFinishedProductsIcon from "../../components/Icons/ApparelFinishedProductsIcon";
import PrimaryMetalIndustriesIcon from "../../components/Icons/PrimaryMetalIndustriesIcon";
import RubberMiscellaneousPlasticProductsIcon from "../../components/Icons/RubberMiscellaneousPlasticProductsIcon";
import ElectronicEquipmentComponentsIcon from "../../components/Icons/ElectronicEquipmentComponentsIcon";
import { capitalize } from "@mui/material";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [curretnInputFocous, setCurretnInputFocous] = useState("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [data, setData] = useState({
    email: "",
    pswd: "",
  });
  const location = useLocation();
const from = location.state?.from?.pathname || "/home";
const { data: userData, status, loading: userLoading } = useSelector(
  (state) => state.userReducer || {}
);
  const changeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setData({ ...data, [name]: value });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (data.email === "" || !emailRegex.test(data.email)) {
      toast.error("Please enter valid email", {
        position: "bottom-center",
        toastId: "pswd-mismatch",
      });
    } else if (data.pswd === "") {
      toast.error("Please enter password", {
        position: "bottom-center",
        toastId: "pswd-mismatch",
      });
    } else {
      dispatch(loginUser(data));
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      dispatch(loginGoogleUser(codeResponse, navigate));
    },
    onError: (errorResponse) => console.log(errorResponse),
  });
  const { linkedInLogin } = useLinkedIn({
    clientId: "78nj9df5hr5l6z",
    redirectUri: "http://sylvr.co.in/linkedinlogin", // for Next.js, you can use `${typeof window === 'object' && window.location.origin}/linkedin`
    onSuccess: (code) => {
      console.log(code);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const ChartIcon = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M3 3v18h18v-2H5V3H3zm4 10h2v5H7v-5zm4-4h2v9h-2v-9zm4-4h2v13h-2V5z"
      />
    </Icon>
  );

  const CalendarIcon = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M7 10h5v5H7v-5zm6 0h5v5h-5v-5zM3 4h1V2h2v2h10V2h2v2h1a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2zm0 16h18V8H3v12z"
      />
    </Icon>
  );

  const UserIcon = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"
      />
    </Icon>
  );

  const BuildingIcon = createIcon({
    displayName: "BuildingIcon",
    viewBox: "0 0 24 24",
    path: <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />,
  });
useEffect(() => {
  if (status) {
    console.log("LOGIN SUCCESS → redirect:", from);
    navigate(from, { replace: true });
  }
}, [status, from, navigate]);
  useEffect(() => {
  console.log("===== LOGIN DEBUG START =====");
  console.log("Current URL:", window.location.pathname);
  console.log("Location object:", location);
  console.log("Location state:", location.state);
  console.log("Original route (from):", location.state?.from);
  console.log("Redirect path:", from);
  console.log("===== LOGIN DEBUG END =====");
}, []);

  return (
    <>
      <Box
        display="flex"
        flexDirection={{ base: "column", md: "row" }}
        minH="100vh"
      >
        {/* Left Section - Info Panel */}
        <Box
          bg="#30D5C8"
          color="white"
          w={{ base: "100%", md: "50%" }}
          px={{ base: 4, md: 10 }}
          py={0}
        >
          <Box textAlign="center" pt={0}>
            <Link to="https://beta.sylvr.co.in">
              <Img
                src={sylvr_logo}
                width="150px"
                mx="auto"
                filter="brightness(0) invert(1)"
              />
            </Link>
          </Box>
          <Text fontSize="2xl" fontWeight="bold" mb={4} textAlign="center">
            Achieve business goals with directional insights
          </Text>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={6}>
            <Box bg="white" color="black" p={4} borderRadius="md">
              <ChartIcon boxSize={6} color="#30D5C8" mb={2} />
              <Text fontWeight="semibold">Track relevant metrics</Text>
              <Text fontSize="sm">
                Dive deep into EBITDA%, ROE, Revenue Growth, Materials% & more
              </Text>
            </Box>

            <Box bg="white" color="black" p={4} borderRadius="md">
              <CalendarIcon boxSize={6} color="#30D5C8" mb={2} />
              <Text fontWeight="semibold">Summarize SME activity</Text>
              <Text fontSize="sm">
                Explore trends for past 7 years. Our AI assistant will guide you
              </Text>
            </Box>

            <Box bg="white" color="black" p={4} borderRadius="md">
              <UserIcon boxSize={6} color="#30D5C8" mb={2} />
              <Text fontWeight="semibold">Get personalized expertise</Text>
              <Text fontSize="sm">
                Expert recommendations adapted to your business trends and
                diagnostics
              </Text>
            </Box>

            <Box bg="white" color="black" p={4} borderRadius="md">
              <BuildingIcon boxSize={6} color="#30D5C8" mb={2} />
              <Text fontWeight="semibold">Connect with suppliers</Text>
              <Text fontSize="sm">
                Profile partnerships based on your vision alignment
              </Text>
            </Box>
          </SimpleGrid>

          <Text fontSize="sm" mb={2}>
            Industries Analysed
          </Text>
          <Flex gap={2} flexWrap="wrap" mb={4}>
            {[
              FoodKindredProductsIcon,
              FabricatedMetalProductsIcon,
              PaperAlliedProductsIcon,
              IndustrialCommercialMachineryComputerEquipmentIcon,
              TextileMillProductsIcon,
              TransportationEquipmentIcon,
              ApparelFinishedProductsIcon,
              PrimaryMetalIndustriesIcon,
              RubberMiscellaneousPlasticProductsIcon,
              ElectronicEquipmentComponentsIcon,
            ].map((IconComponent, i) => (
              <Box
                key={i}
                fontSize="20px"
                bg="white"
                color="black"
                px={3}
                py={2}
                borderRadius="md"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <IconComponent color="#30D5C8" />
              </Box>
            ))}
          </Flex>

          <Flex direction="column" align="center" justify="center" mt={6}>
            <Button
              bg="#FFAA00"
              color="#162421"
              borderRadius="10px"
              px={130}
              fontWeight="bold"
              leftIcon={
                <div
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    border: '2px solid #162421',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Icon viewBox="0 0 20 20" color="#162421">
                    <path fill="currentColor" d="M6 4l10 6-10 6V4z" />
                  </Icon>
                </div>
              }


            >
              View A Demo
            </Button>
            <Text fontSize="xs" mt={2} color="black">
              No credit card required | Cancel anytime
            </Text>
          </Flex>
        </Box>
        {/* Right Section - Form Panel */}
        <Box
          w={{ base: "100%", md: "50%" }}
          px={{ base: 4, md: 12 }}
          py={0}
          bg="white"
        >
          <Box height="80vh">
            <Container
              minHeight="100vh"
              w={["100%", "90%", "80%"]}
              padding="10px"
            >
              <form className="loginform" onSubmit={submitHandler}>
                <Box p={4} w="100%">
                  <VStack spacing={4} align="stretch">
                    <Text
                      w={"100%"}
                      color="#4E6565"
                      fontSize="16px"
                      fontWeight={600}
                      letterSpacing=".9px"
                      margin={"0px"}
                      textAlign={"left"}
                    >
                      Welcome back,
                    </Text>
                    <Text fontWeight={600} textTransform="UpperCase">Login to continue your journey</Text>
                    <Box
                      mt="10px"
                      padding="20px 30px"
                      boxShadow="0px 0px 75px 0px rgba(0, 0, 0, 0.06);"
                      borderRadius="8px"
                      background="#F8FDFD"
                    >
                      <Box>
                        {/* <FormLabel
                          fontWeight={400}
                          fontSize={"13px"}
                          textColor={"#0C543C"}
                          w={"511px"}
                          mb={0}
                        >
                          Email
                        </FormLabel> */}
                        <Input
                          maxW="100%"
                          type="email"
                          name="email"
                          placeholder={
                            curretnInputFocous === "email" ? "" : "Email"
                          }
                          value={data.email}
                          focusBorderColor="#30d5c8"
                          focusborderwidth="5px"
                          transition="height 0.3s"
                          fontWeight={"600"}
                          fontSize={18}
                          mb={3}
                          bg="#F2F7F7"
                          onFocus={() => setCurretnInputFocous("email")}
                          onBlur={() => setCurretnInputFocous("")}
                          _placeholder={{
                            fontWeight: "400",
                            fontSize: "18px",
                            color: "#4E6565",
                          }}
                          _focus={{
                            height: "3rem",
                            borderLeft: "5px solid #30d5c8",
                          }}
                          _hover={{
                            _placeholder: {
                              color: "#30d5c8",
                            },
                          }}
                          onChange={changeHandler}
                          isRequired
                        />
                      </Box>

                      <Box>
                        {/* <FormLabel
                          fontWeight={400}
                          fontSize={"13px"}
                          textColor={"#0C543C"}
                          w={"511px"}
                          mb={0}
                        >
                          Password
                        </FormLabel> */}
                        <InputGroup>
                          <Input
                            maxW="100%"
                            type={showPassword ? "text" : "password"}
                            name="pswd"
                            value={data.pswd}
                            bg="#F2F7F7"
                            placeholder={
                              curretnInputFocous === "pswd" ? "" : "Password"
                            }
                            focusBorderColor="#30d5c8"
                            focusborderwidth="5px"
                            transition="height 0.3s"
                            fontWeight={"600"}
                            fontSize={18}
                            onFocus={() => setCurretnInputFocous("pswd")}
                            onBlur={() => setCurretnInputFocous("")}
                            _placeholder={{
                              fontWeight: "400",
                              fontSize: "18px",
                              color: "#4E6565",
                            }}
                            _focus={{
                              height: "3rem",
                              borderLeft: "5px solid #30d5c8",
                            }}
                            onChange={changeHandler}
                            isRequired
                            _hover={{
                              _placeholder: {
                                color: "#30d5c8",
                              },
                            }}
                          />
                          <InputRightElement width="4.5rem" h={"100%"}>
                            <IconButton
                              h="1.75rem"
                              size="md"
                              onClick={() => setShowPassword(!showPassword)}
                              bg={"#fff"}
                              color={"#30d5c8"}
                              icon={
                                showPassword ? <ViewOffIcon /> : <ViewIcon />
                              }
                            />
                          </InputRightElement>
                        </InputGroup>
                      </Box>

                      <Button
                        type="submit"
                        borderRadius="8px"
                        fontSize={{ base: "14px", md: "18px" }}
                        fontWeight={600}
                        width="100%"
                        mt="5px"
                        paddingY={{ base: "12px", md: "10px" }}
                        height={"auto"}
                        color={"#30D5C8"}
                        bg={"white"}
                        variant={"solid"}
                        onClick={submitHandler}
                        _hover={{
                          boxShadow: "lg",
                        }}
                      >
                        Login
                      </Button>
                      <Flex className="forgot-signup-block">
                        <Box textAlign="center">
                          <a
                            href="/password/forgot"
                            className="forgot-block"
                            style={{
                              borderBottom: "2px solid #30D5C8",
                              textDecoration: "none",
                              color: "#162421",
                            }}
                            onMouseEnter={(e) => (e.target.style.color = "#FFAA00")}
                            onMouseLeave={(e) => (e.target.style.color = "#162421")}
                          >
                            Forgot Password? Reset it here
                          </a>
                        </Box>

                      </Flex>
                      {/* <HStack>
                        <Divider />
                        <Text
                          textStyle="sm"
                          whiteSpace="nowrap"
                          color="fg.muted"
                        >
                          or continue with
                        </Text>
                        <Divider />
                      </HStack> */}
                      {/* <Box textAlign={"center"}>
                        <Button
                          onClick={() => googleLogin()}
                          key={"Google"}
                          flexGrow={1}
                          bg="inherit"
                        >
                          <GoogleIcon />
                        </Button>
                        <Button
                          onClick={linkedInLogin}
                          key={"Linkedin"}
                          flexGrow={1}
                          bg="inherit"
                        >
                          <Img
                            src={linkedin_icon}
                            alt="linkedin icon"
                            style={{ width: "30px" }}
                          />
                        </Button>
                      </Box> */}
                    </Box>
                  </VStack>

                  <HStack width="100%" justifyContent={"center"} mt={3}>
                    <Text
                      fontWeight={400}
                      fontSize={["12px", "14px", "16px"]}
                      pt={"13px"}
                      textColor={"#1E1E1E"}
                    >
                      Don’t have an account?
                    </Text>
                    <Text
                      mt={"10px"}
                      fontWeight={600}
                      fontSize={["12px", "14px", "16px"]}
                      textColor={"#000"}
                      bg={"#30D5C8"}
                      onClick={() => navigate("/register")}
                      _hover={{
                        cursor: "pointer",
                      }}
                    >
                      Create one!
                    </Text>
                  </HStack>
                </Box>
              </form>
            </Container>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Login;
